module.exports = __webpack_public_path__ + "img/grid-item-1.85fe80f1.jpg";